export class User {
  isSelected: boolean = false
  name: string
  email: string
  last_access_at: string
  school_name: string
  role: string

  constructor(user: any){
    this.name = user.name;
    this.email = user.email;
    this.last_access_at = user.last_access_at;
    this.school_name = user.school_name;
    this.role = user.role; 
  }
}

export class SearchCondition {
  school_id: string = ""
  name: string = ""
  role: string = ""
  last_access_at: string = ""
}